import { useMemo, useState } from 'react';
import { ALL_STATUSES, toRowStatus } from '../utils/deliveryStatus';

export default function useDeliveryRows(deliveries) {
  const [statusFilter, setStatusFilter] = useState(ALL_STATUSES);

  const allRows = useMemo(
    () =>
      (deliveries ?? [])
        .map((d) => ({ ...d, rowStatus: toRowStatus(d.status) }))
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
    [deliveries],
  );

  const rows = useMemo(
    () => allRows.filter((d) => statusFilter.includes(d.rowStatus)),
    [allRows, statusFilter],
  );

  return { allRows, rows, statusFilter, setStatusFilter };
}
